import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderHistoryPageContext } from "@insite/content-library/Pages/OrderHistoryPage";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const contactNameStyles: SearchTextFieldStyles = {};
const styles = contactNameStyles;

const OrderHistorySearchContactName: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField styles={styles} parameterField="search" label="Contact Name" inputType="text" placeholder="" />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchContactName,
    definition: {
        group: "Order History",
        displayName: "Contact Name",
        allowedContexts: [OrderHistoryPageContext],
    },
};

export default widgetModule;
